export const formatNumber = (number = 0) => {
  return Number(number)
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
};

export const formatPriceTR = (price) => price.toLocaleString("tr-TR", { style: 'currency', currency: 'TRY' });
